import React, { useState } from "react";
import { Icon } from "@coverme/icons";
import { TooltipMessage, TooltipTrigger } from "@coverme/elements";
import { SimpleSingleSelect } from "../../../components/FormComponents/SimpleSingleSelect";
import { noop } from "lodash-es";
import { CTA, InputField } from "@coverme/forms";
import { CoverMeDropzone } from "./CoverMeDropzone";
import { Tooltip } from "../../../components/Tooltips/Tooltip";
import "../../../components/InterviewDocuments/InterviewDocuments.scss";

function getTooltipMessage(documentType) {
    switch (documentType) {
        case "Proof of Assets":
            return "Most recent statement for all checking, savings and credit union account";
        case "Financial Assistance Application":
            return "Signed and approved, Denied";
        case "Proof of Government Assistance":
            return "Women, Infants and Children Nutrition Program (WIC), Supplemental Nutrition Assistance Program (SNAP), School Free Lunch Program, Medicaid eligibility determination letterTax Documents - Most recent Federal Tax return, Most recent W-2, etc";
        case "Proof of Identity":
            return "State issued photo ID, Passport, etc.";
        case "Proof of Income":
            return "Copies of most recent paycheck stubs, most recent Social Security payments, unemployment payments";
        case "Insurance Card":
            return "Front and Back";
        case "Proof of Non-Wage Income":
            return "Statement of business income, alimony income, retirement or pension income";
        case "Proof of Residency":
            return "State issued photo ID, utility bill, voter registration card, current mail from governmental source, letter from a homeless shelter, etc.";
        default:
            return null;
    }
}

export const DocumentForm = ({ documentTypes, patientName, onCancel, onSubmit }) => {
    const [uploadedFile, setUploadedFile] = useState([]);
    const [documentType, setDocumentType] = useState(null);
    const [documentSubType, setDocumentSubType] = useState("");
    const [isFormValid, setIsFormValid] = useState(true);

    function submit() {
        if (documentType == null || uploadedFile.length === 0) {
            setIsFormValid(false);
            return;
        } else {
            setIsFormValid(true);
        }

        onSubmit(documentType, documentSubType, uploadedFile[0]);
    }

    const tooltipMessage = getTooltipMessage(documentType);

    return (
        <div className="upload-form">
            <CoverMeDropzone
                onFileSelect={setUploadedFile}
                isValid={isFormValid === true || uploadedFile.length > 0}
                errorMessage={"Required"}
                allowedFileExtensions={[
                    ".doc",
                    ".docx",
                    ".rft",
                    ".txt",
                    ".pdf",
                    ".jpg",
                    ".jpeg",
                    ".png",
                    ".tif",
                    ".bmp",
                    ".heif",
                    ".gif",
                ]}
            />
            {uploadedFile?.length > 0 && (
                <>
                    <div className="upload-form-controls">
                        <div className="document_type_control">
                            {tooltipMessage != null && (
                                <div className="document_type_tooltip">
                                    <Tooltip>
                                        <TooltipTrigger>
                                            <Icon icon={"tooltip"} />
                                        </TooltipTrigger>
                                        <TooltipMessage>
                                            <div>{tooltipMessage}</div>
                                        </TooltipMessage>
                                    </Tooltip>
                                </div>
                            )}
                            <SimpleSingleSelect
                                id="document_type_control"
                                options={documentTypes}
                                setFieldTouched={noop}
                                title="Document Type"
                                className="document_type"
                                name={"documentType"}
                                setFieldValue={(e, v) => {
                                    setDocumentType(v);
                                }}
                                value={documentType}
                                validState={isFormValid === true || documentType != null ? "valid" : "invalid"}
                                errorMessage={"Required"}
                            />
                        </div>

                        <InputField
                            id="document_sub_type_control"
                            changeEvent={e => {
                                setDocumentSubType(e.currentTarget.value);
                            }}
                            disabled={false}
                            name={"document_subType"}
                            placeholder={"Document Name"}
                            title={"Document Name"}
                            type={"text"}
                            value={documentSubType}
                        />
                    </div>
                    <div className="submit-button">
                        <CTA styleType={"blue-alt"} size="large" disabled={false} ctaType={"button"} click={submit}>
                            Upload
                        </CTA>
                    </div>
                </>
            )}
        </div>
    );
};
